import css from 'styled-jsx/css';
import { sansSerif } from 'styles/css-constants';
import { MQ_LARGE } from 'constants/mq';

export const nutritionalGuideStyles = css`
  .NutritionalGuide {
    font-family: ${sansSerif};
  }

  .NutritionalGuide__footer {
    display: flex;
    justify-content: center;
  }

  .NutritionalGuide__footer a {
    border-bottom: none;
  }

  .NutritionalGuide__labels {
    columns: 2;
  }

  .NutritionalGuide__list {
    padding: 0;
    margin: 0 0 1rem;
    list-style: none;
  }

  .NutritionalGuide__list li {
    font-size: var(--fontScaleNeg2);
    line-height: 1.5;
  }

  .NutritionalGuide__servings {
    margin-bottom: 0.75rem;
    font-size: var(--fontScaleNeg2);
    font-weight: bold;
  }

  @media screen and ${MQ_LARGE} {
    .NutritionalGuide__list li,
    .NutritionalGuide__servings {
      font-size: var(--fontScaleNeg1);
    }
  }

  @supports (display: grid) {
    .NutritionalGuide__nutrient {
      display: grid;
      grid-template:
        'name filler quantity'
        / min-content 1fr max-content;
      align-items: baseline;
      margin-bottom: 0.5rem;
    }

    .NutritionalGuide__nutrient::before {
      content: '';
      grid-area: filler;
      border-bottom: 1px dotted #000;
    }

    .NutritionalGuide__nutrient-name {
      grid-area: name;
    }

    .NutritionalGuide__nutrient-quantity {
      grid-area: quantity;
    }
  }
`;

export default { nutritionalGuideStyles };
